import React, {useContext} from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../AppContext";

import StatusComp from "../common/StatusComp";
import { GetOrganizationName } from "../common/Utils";

const SummaryItemComp = (props) => {
    const [appContext, setAppContext] = useContext(AppContext);
    const isJwCole = appContext.clientId === "jwcole"?true:false;
  const getDescription = (item) => {
    if (isJwCole && item.reqType === 'political')
        return GetOrganizationName(item.formData);
        
    return item.description;
  }

  return (

    <ul className="flex-table">
        <li className="table-row table-header">
            <div className="table-data">
                <div className="table-cell">Request Date</div>
                <div className="table-cell">Request Type</div>
                <div className="table-cell">Description</div>
                {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') &&
                    <>
                    <div className="table-cell">Employee</div>
                    <div className="table-cell">Submitted By</div>
                    </>
                }
                <div className="table-cell">Request Status</div>
            </div>
        </li>

        {props.items.map(item => {
            return (
                <li key={item.id + item.reqType}  className="table-row clickable" onClick={p => props.onDetail(item)}>
                    <div className="table-data">
                        <div className="table-cell" data-title="Request Date : ">{item.reqDate}</div>
                        <div className="table-cell" data-title="Request Type : ">{item.reqType}</div>
                        <div className="table-cell" data-title="Description : ">{ getDescription(item) }</div>
                        {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') &&
                            <>
                            <div className="table-cell" data-title="Employee : ">{item.employeeName}</div>
                            <div className="table-cell" data-title="Submitted By : ">{item.submittedBy}</div>
                            </>
                        }
                        <div className="table-cell" data-title="Status : "><StatusComp status={item.status}>{item.statusLabel}</StatusComp></div>
                    </div>
                    
                </li>
            )
        })
        }
    </ul>
  );
};

export default SummaryItemComp;
